import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { CaseManagerRoutingModule } from "./case-manager-routing.module";
import { LoginGuard } from "../auth/loginGuard";
import { AuthService } from "../auth/auth.service";
import { UserService } from "../core/services/v2/user.service";
import { CommonService } from "../core/services/v2/common.service";
import { PhysicianService } from "../physician/physician.service";
import {
  MatStepperModule,
  MAT_DIALOG_DEFAULT_OPTIONS,
} from "@angular/material";
import { AgmCoreModule } from "@agm/core";
import { HttpClientModule } from "@angular/common/http";
import { CoreModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModalModule, NgbCollapseModule } from "@ng-bootstrap/ng-bootstrap";
import { CKEditorModule } from "ckeditor4-angular";
import { RatingModule } from "ng-starrating";
import { NgxMaskModule } from "ngx-mask";
import { MaterialModule } from "../material/material-module";
import { SharedModule } from "../shared/shared.module";
import { CasemanagerHeaderLayoutComponent } from "./layout/casemanager-header-layout/casemanager-header-layout.component";
import { CasemanagerLayoutComponent } from "./layout/casemanager-layout/casemanager-layout.component";
import { CasemanagerSidebarComponent } from './layout/casemanager-sidebar/casemanager-sidebar.component';
import { CasemanagerDashboardComponent } from './casemanager-dashboard/casemanager-dashboard.component';
import { CaselistComponent } from './caselist/caselist.component';
import { SaveCaseComponent } from './save-case/save-case.component';
import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { CaseSummaryComponent } from './caselist/case-summary/case-summary.component';
import { AddPatientDialogComponent } from './save-case/add-patient-dialog/add-patient-dialog.component';
import { CaseDocDialogOverview, CaseDocumentsComponent } from './caselist/case-documents/case-documents.component';
import { NursingNoteComponent } from './caselist/nursing-note/nursing-note.component';
import { AddnoteDialogComponent } from './caselist/nursing-note/addnote-dialog/addnote-dialog.component';
import { ScrollingModule } from "@angular/cdk/scrolling";
import { EllipsisModule } from "ngx-ellipsis";
import { AssigncasemanagerComponent, WarningDialog } from './caselist/assigncasemanager/assigncasemanager.component';
import { CasemanagerLayoutWithoutSelectorComponentComponent } from './layout/casemanager-layout/casemanager-layout-without-selector-component.component';
import { CasecommunicationComponent } from './caselist/casecommunication/casecommunication.component';

@NgModule({
  imports: [
    RatingModule,
    FormsModule,
    CommonModule,
    MatStepperModule,
    HttpClientModule,
    NgbModalModule,
    NgbCollapseModule,
    MaterialModule,
    AgmCoreModule,
    ReactiveFormsModule,
    SharedModule,
    CoreModule,
    CKEditorModule,
    CommonModule,
    CaseManagerRoutingModule,
    NgxMaskModule.forRoot(),
    AutocompleteLibModule,
    ScrollingModule,
    EllipsisModule 
  ],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    PhysicianService,
    CommonService,
    UserService,
    AuthService,
    LoginGuard,
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { hasBackdrop: true, direction: "ltr" },
    },
  ],
  declarations: [
    CasemanagerLayoutComponent,
    CasemanagerHeaderLayoutComponent,
    CasemanagerSidebarComponent,
    CasemanagerDashboardComponent,
    CaselistComponent,
    SaveCaseComponent,
    CaseSummaryComponent,
    AddPatientDialogComponent,
    CaseDocumentsComponent,
    CaseDocDialogOverview,
    NursingNoteComponent,
    AddnoteDialogComponent,
    AssigncasemanagerComponent,
    WarningDialog,
    CasemanagerLayoutWithoutSelectorComponentComponent,
    CasecommunicationComponent
  ],

  bootstrap: [CasemanagerLayoutComponent],
  entryComponents: [CaseSummaryComponent,AddPatientDialogComponent,WarningDialog,
    CaseDocDialogOverview,AddnoteDialogComponent]
})
export class CaseManagerModule {}
